import React from 'react';
import { Grid } from '@material-ui/core';
import { AnnouncementsCard } from '@procore-oss/backstage-plugin-announcements';
import { Content, Header, Page } from '@backstage/core-components';

export const AnnouncementPage = () => {
  return (
    <Page themeId="home">
      <Header title="News" />

      <Content>
        <Grid container>
          <Grid item xs={12}>
            <AnnouncementsCard max={3} />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
